/**
 * NO03 - Fakturakopi Action Types
 */

// Search
export const NO03_SEARCH_REQUEST = 'NO03_SEARCH_REQUEST';
export const NO03_SEARCH_SUCCESS = 'NO03_SEARCH_SUCCESS';
export const NO03_SEARCH_FAILURE = 'NO03_SEARCH_FAILURE';

// Load more (pagination)
export const NO03_LOAD_MORE_REQUEST = 'NO03_LOAD_MORE_REQUEST';
export const NO03_LOAD_MORE_SUCCESS = 'NO03_LOAD_MORE_SUCCESS';
export const NO03_LOAD_MORE_FAILURE = 'NO03_LOAD_MORE_FAILURE';

// Clear/Reset
export const NO03_CLEAR_RESULTS = 'NO03_CLEAR_RESULTS';
export const NO03_RESET_FORM = 'NO03_RESET_FORM';

// Firma selection
export const NO03_SET_FIRMA = 'NO03_SET_FIRMA';
export const NO03_LOAD_FIRMA_LIST = 'NO03_LOAD_FIRMA_LIST';
export const NO03_LOAD_FIRMA_LIST_SUCCESS = 'NO03_LOAD_FIRMA_LIST_SUCCESS';
export const NO03_LOAD_FIRMA_LIST_FAILURE = 'NO03_LOAD_FIRMA_LIST_FAILURE';

// Component store management
export const NO03_CLEAR_COMPONENT_STORE = 'NO03_CLEAR_COMPONENT_STORE';
